import React from "react";
import "../css/about.scss";
function About() {
  return (
    <div className="about">
      <div className="about__container">
        <h1 className="about__title">ABOUT US</h1>

        <div className="about__images">
          <img
            src="/generated/editorial/about-craft.jpg"
            alt="danecay footwear artisan"
            className="about__image--main"
          />
          <img
            src="/generated/editorial/about-materials.jpg"
            alt="Leather, thread and shoemaking materials"
            className="about__image--secondary"
          />
        </div>

        <p className="about__tagline">
          Handmade, Original Design, Genuine Leather.
        </p>

        <div className="about__content">
          <p className="about__paragraph">
            danecay is a Hong Kong footwear brand focused on comfortable,
            original leather shoes for everyday life. We develop boots, flats,
            loafers, sandals and pumps with balanced proportions, practical
            soles and materials chosen for how they feel as well as how they
            age. Our aim is to make thoughtful design accessible without
            compromising on fit or finishing.
          </p>

          <p className="about__paragraph">
            Every danecay style begins with a clear purpose: a secure commuter
            shoe, a soft weekend flat or a confident boot for cooler days. Our
            team reviews the last, upper pattern, seam placement, cushioning and
            outsole together so that visual details support real wearability.
          </p>

          <p className="about__paragraph">
            This website is the official online store for danecay. Product
            questions, order support and policy enquiries are handled at
            core@danecay.shop.
          </p>
        </div>

        <h2 className="about__section-title">PRODUCTS</h2>

        <div className="about__products">
          <p className="about__paragraph">
            We offer a wide range of handcrafted women's shoes, including:{" "}
            <span className="about__highlight">
              boots, oxfords & tie, mary jane, loafers, flats, sandals,
              slippers, sneakers, wedges, platforms, pumps, large size shoes.
            </span>{" "}
            We choose the best quality leather and finest waxed cotton thread to
            make each pair of shoes. Every item in our shop is handmade with
            care.
          </p>

          <p className="about__paragraph">
            If you have special requests, please contact us — we would love to
            help bring your ideas to life and provide you with the finest
            leather goods.
          </p>

          <p className="about__paragraph">
            The comfort of our shoes is determined by the shoe last (the mold
            used for shaping shoes), leather quality, sole type, and the
            craftsperson's experience. We choose the best leather for its
            thickness, grain, and feel. We constantly refine our shoe lasts to
            shape each upper accurately. danecay soles are selected for comfort
            and flexibility. Each shoe is carefully finished by an
            experienced artisan. You will find that our colors, the curve of our
            shoe heel and toe, and the texture of our leather are quite
            different from many commercial brands.
          </p>

          <p className="about__paragraph">
            We are grateful for the gifts of nature. We cherish the materials we
            use and do our best to make every shoe well, minimizing leather
            waste in the process.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
